import Button from 'gu-ui-kit/Button'
import Grid from 'gu-ui-kit/Grid/Container'
import Typography from 'gu-ui-kit/Typography'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const NotFound = ({ homePath }) => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet defer={false}>
        <title>{t('common::not_found.title', 'Страница не найдена')}</title>
      </Helmet>
      <Grid
        alignItems={'center'}
        className={'padding-top-80 padding-bottom-80'}
        direction={'column'}
        justifyContent={'center'}
        wrap={false}
      >
        <Typography
          className={'margin-bottom-16'}
          color={'Label-Fifth'}
          component={'h1'}
          variant={'Body-Accent-40'}
        >
          <Trans i18nKey={'common::not_found.title'}>Страница не найдена</Trans>
        </Typography>
        <Typography
          className={'margin-bottom-40'}
          color={'Label-Secondary'}
          component={'p'}
          variant={'Body-20'}
        >
          <Trans i18nKey={'common::not_found.description'}>
            Такой страницы нет или ссылка устарела.
          </Trans>
        </Typography>
        <Button
          component={Link}
          to={homePath}
          variant={'primary'}
        >
          <Trans i18nKey={'common::not_found.action'}>На главную</Trans>
        </Button>
      </Grid>
    </>
  )
}

NotFound.propTypes = {
  homePath: PropTypes.string.isRequired,
}

export default NotFound
